export default __webpack_public_path__ + "static/media/480_dummy2016-delikatessen01.7a7b2abc.png";